import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LucideAngularModule } from 'lucide-angular';
import { SpinnerComponent } from '../../../components/spinner/spinner.component';
import { Icons } from '../../../../shared/helpers/icons';
import { UserDataService } from '../../../../shared/services/userData.service';
import { IEmergencyEvacuationKit } from '../../../../shared/models/emergencyEvacuationKit';
import { EmergencyEvacuationKitsService } from '../../../../shared/services/emergencyEvacuationKits.service';

@Component({
  selector: 'emergency-evacuation-kit-form',
  standalone: true,
  imports: [CommonModule, FormsModule, LucideAngularModule, SpinnerComponent],
  templateUrl: './emergency-evacuation-kit-form.component.html'
})
export class EmergencyEvacuationKitFormComponent implements OnInit {

  icons = Icons;

  @Input() itemToEdit: IEmergencyEvacuationKit | null = null;

  @Output() onClose = new EventEmitter<void>();
  @Output() onSave = new EventEmitter<{ type: string, message: string }>();

  currentBuildingId: string | null = null;
  kit: IEmergencyEvacuationKit = {};
  loading: boolean = false;

  constructor(
    private userDataService: UserDataService,
    private emergencyEvacuationKitsService: EmergencyEvacuationKitsService
  ) {}

  ngOnInit(): void {
    this.currentBuildingId = this.userDataService.getBuildingId();
    this.kit = this.itemToEdit ? { ...this.itemToEdit } : {};
  }

  get isEdit(): boolean {
    return !!this.itemToEdit?.id;
  }

  get isValid(): boolean {
    return !!(this.kit.name && this.kit.location);
  }

  closeModal(): void {
    this.onClose.emit();
  }

  save(): void {
    if (!this.currentBuildingId || !this.isValid) return;

    const payload: Partial<IEmergencyEvacuationKit> = {
      name: this.kit.name,
      location: this.kit.location,
    };

    this.loading = true;
    const request$ = this.isEdit
      ? this.emergencyEvacuationKitsService.updateEmergencyEvacuationKit(this.currentBuildingId, String(this.itemToEdit!.id), payload)
      : this.emergencyEvacuationKitsService.createEmergencyEvacuationKit(this.currentBuildingId, payload);

    request$.subscribe({
      next: (response) => {
        this.loading = false;
        if (!response.has_error) {
          this.onSave.emit({ type: 'success', message: this.isEdit ? 'This occurred after updating an evacuation kit.' : 'This occurred after adding an evacuation kit.' });
        } else {
          this.onSave.emit({ type: 'unsuccess', message: response.message });
        }
      },
      error: (err) => {
        this.loading = false;
        this.onSave.emit({ type: 'unsuccess', message: err.message });
      }
    });
  }
}
